<!-- begin::Quick Sidebar -->
@if (sidebarService.isOpen()) {
    <div class="m-quick-sidebar-overlay" (click)="sidebarService.close()"></div>
}
<div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light"
    [class.m-quick-sidebar--on]="sidebarService.isOpen()"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'entitySidebar.filterHotels' | transloco"
    [attr.aria-hidden]="!sidebarService.isOpen()"
    [inert]="!sidebarService.isOpen()"
    [cdkTrapFocus]="sidebarService.isOpen() && !showHotelList">
    <div class="m-quick-sidebar__content">
        <div class="pulse-filter-heading">
            <h2>{{ 'entitySidebar.filterHotels' | transloco }}</h2>
            <button
                type="button"
                class="pulse-filter-customize"
                (click)="customizingFilters = !customizingFilters"
                [attr.aria-expanded]="customizingFilters"
                aria-controls="pulse-filter-customizer">
                <i class="fa fa-sliders" aria-hidden="true"></i>
                {{ (customizingFilters ? 'entitySidebar.done' : 'entitySidebar.customizeFilters') | transloco }}
            </button>
            <button
                type="button"
                class="m-quick-sidebar__close sidebar-close-btn"
                (click)="sidebarService.close()"
                [attr.aria-label]="'entitySidebar.closeFilters' | transloco">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>
        <div class="row g-0 justify-content-left">
            <div class="pulse-filter-actions">
                <div class="pulse-filter-count" role="status">
                    {{ 'entitySidebar.hotelsSelected' | transloco: { count: pendingHotelCount } }}
                </div>

                <button
                    type="button"
                    class="btn btn-primary pulse-filter-apply"
                    [title]="'entitySidebar.applyCurrent' | transloco"
                    [attr.aria-label]="'entitySidebar.applyCurrent' | transloco"
                    (click)="updateFilters()">
                    <i class="fa fa-check" aria-hidden="true"></i>
                </button>

                <button class="btn btn-block btn-sidebar pulse-filter-clear" (click)="clearAllSelection()">
                    <i class="fa fa-times" style="margin-right: 6px"></i>
                    {{ 'entitySidebar.clearAll' | transloco }}
                </button>

                <button
                    class="btn btn-block btn-sidebar"
                    [title]="'entitySidebar.saveSelectionTooltip' | transloco"
                    (click)="showSaveSelectionModal()">
                    <i class="fa fa-save" style="margin-right: 6px"></i>
                    {{ 'entitySidebar.saveSelection' | transloco }}
                </button>

                @if (savedSelections.length > 0) {
                    <div class="custom-dropdown">
                        <button
                            class="dropdown-toggle"
                            type="button"
                            (click)="toggleDropdown()"
                            [class.active]="showDropdown">
                            <i class="fa fa-bookmark"></i>
                            <span
                                class="pulse-saved-selection-label"
                                [title]="selectedSavedSelection || ('entitySidebar.loadSavedSelection' | transloco)">
                                {{ selectedSavedSelection || ('entitySidebar.loadSavedSelection' | transloco) }}
                            </span>
                            <i class="fa fa-chevron-down dropdown-arrow" [class.rotated]="showDropdown"></i>
                        </button>
                        <div class="dropdown-menu" [class.show]="showDropdown">
                            <div class="dropdown-header">
                                <span>{{ 'entitySidebar.savedSelections' | transloco }}</span>
                                <span
                                    ><small
                                        >{{ savedSelections.length }} {{ 'entitySidebar.saved' | transloco }}</small
                                    ></span
                                >
                            </div>
                            <div class="dropdown-items">
                                @for (selection of savedSelections; track trackBySelectionName($index, selection)) {
                                    <div class="dropdown-item">
                                        <div class="selection-info" (click)="loadSpecificSelection(selection.name)">
                                            <div class="selection-name">{{ selection.name }}</div>
                                            <div class="selection-count">
                                                {{ getSelectionCount(selection.value) }}
                                                {{ 'entitySidebar.hotels' | transloco }}
                                            </div>
                                        </div>
                                        <div class="selection-actions">
                                            <button
                                                class="action-btn update-btn"
                                                (click)="updateSelection($event, selection.name)"
                                                [title]="'entitySidebar.updateSelectionTooltip' | transloco">
                                                <i class="fa fa-refresh"></i>
                                            </button>
                                            <button
                                                class="action-btn delete-btn"
                                                (click)="deleteSelection($event, selection.name)"
                                                [title]="'entitySidebar.deleteSelectionTooltip' | transloco">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (savedSelections.length === 0) {
                                <div class="dropdown-footer">
                                    <span class="no-selections">{{ 'entitySidebar.noSelections' | transloco }}</span>
                                </div>
                            }
                        </div>
                    </div>
                }

                <button
                    class="btn btn-tertiary btn-block btn-sidebar"
                    [title]="'entitySidebar.showCurrentSelection' | transloco"
                    (click)="onShowClick()">
                    <i class="fa fa-list" style="margin-right: 6px"></i>
                    {{ 'entitySidebar.showCurrentSelection' | transloco }}
                </button>
            </div>
        </div>
        <div
            class="modal"
            [class.show]="showSaveModal"
            [style.display]="showSaveModal ? 'block' : 'none'"
            style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 1050;
            ">
            <div style="margin: 10vh auto; max-width: 500px; background: white; padding: 20px; border-radius: 5px">
                <h5>
                    {{
                        isUpdateMode
                            ? ('entitySidebar.updateHotelSelection' | transloco)
                            : ('entitySidebar.saveHotelSelection' | transloco)
                    }}
                </h5>
                <input
                    type="text"
                    [(ngModel)]="newSelectionName"
                    [placeholder]="'entitySidebar.enterSelectionName' | transloco"
                    maxlength="50"
                    style="width: 100%; padding: 8px; margin: 10px 0; border: 1px solid #ccc; border-radius: 4px"
                    (keyup.enter)="saveNamedSelection()" />
                <div style="color: #666; font-size: 12px; margin-bottom: 15px">
                    {{ 'entitySidebar.currentSelection' | transloco }}:
                    {{ entityMapFilters.get('hotel')?.selectedKeys?.length }}
                    {{ 'entitySidebar.hotels' | transloco }}
                    @if (isUpdateMode) {
                        <div style="font-style: italic; margin-top: 5px">
                            {{ 'entitySidebar.youCanChangeNameAndSelection' | transloco }}
                        </div>
                    }
                </div>
                <div style="text-align: right">
                    <button
                        (click)="hideSaveSelectionModal()"
                        style="
                            padding: 8px 16px;
                            margin-right: 10px;
                            background: #6c757d;
                            color: white;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;
                        ">
                        {{ 'common.cancel' | transloco }}
                    </button>
                    <button
                        (click)="saveNamedSelection()"
                        [disabled]="!newSelectionName.trim()"
                        style="
                            padding: 8px 16px;
                            background: #007bff;
                            color: white;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;
                        "
                        [style.background]="!newSelectionName.trim() ? '#ccc' : '#007bff'">
                        {{ isUpdateMode ? ('entitySidebar.update' | transloco) : ('common.save' | transloco) }}
                    </button>
                </div>
            </div>
        </div>
        @if (customizingFilters) {
            <section id="pulse-filter-customizer" class="pulse-filter-customizer">
                <div class="pulse-customizer-heading">
                    <h3>{{ 'entitySidebar.customizeFilters' | transloco }}</h3>
                    <button type="button" (click)="resetFilterLayout()">
                        {{ 'entitySidebar.resetLayout' | transloco }}
                    </button>
                </div>
                <p>{{ 'entitySidebar.customizeHelp' | transloco }}</p>
                <div
                    cdkDropList
                    [cdkDropListData]="customizableFilters"
                    (cdkDropListDropped)="dropFilter($event)"
                    class="pulse-filter-order-list">
                    @for (filter of customizableFilters; track filter; let index = $index) {
                        <div
                            cdkDrag
                            cdkDragLockAxis="y"
                            cdkDragPreviewContainer="parent"
                            class="pulse-filter-order-row">
                            <span cdkDragHandle class="pulse-filter-drag-handle" aria-hidden="true"
                                ><i class="fa fa-grip-vertical"></i
                            ></span>
                            <label>
                                <input
                                    type="checkbox"
                                    [ngModel]="isFilterVisible(filter)"
                                    (ngModelChange)="setFilterVisible(filter, $event)" />
                                <span>{{
                                    filter.id === 'cc' ? ('filters.ccOutsourcedShort' | transloco) : filter.textHeader
                                }}</span>
                            </label>
                            <button
                                type="button"
                                class="pulse-filter-reorder"
                                (click)="moveFilter(index, -1)"
                                [disabled]="index === 0"
                                [attr.aria-label]="'entitySidebar.moveUp' | transloco: { filter: filter.textHeader }">
                                <i class="fa fa-chevron-up" aria-hidden="true"></i>
                            </button>
                            <button
                                type="button"
                                class="pulse-filter-reorder"
                                (click)="moveFilter(index, 1)"
                                [disabled]="index === customizableFilters.length - 1"
                                [attr.aria-label]="'entitySidebar.moveDown' | transloco: { filter: filter.textHeader }">
                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                </div>
                <p class="pulse-layout-storage" role="status">
                    {{ (layoutSaved ? 'entitySidebar.layoutSaved' : 'entitySidebar.layoutNotSaved') | transloco }}
                </p>
            </section>
        }
        @if (filters && visibleFilterCount === 0 && !customizingFilters) {
            <div class="pulse-filter-empty">
                <i class="fa fa-sliders" aria-hidden="true"></i>
                <p>
                    {{
                        (singleHotelAccess ? 'entitySidebar.singleHotelHelp' : 'entitySidebar.noVisibleFilters')
                            | transloco
                    }}
                </p>
                <button type="button" class="pulse-filter-customize" (click)="customizingFilters = true">
                    {{ 'entitySidebar.customizeFilters' | transloco }}
                </button>
            </div>
        }
        <div class="filter-flex wrap" [hidden]="customizingFilters">
            @for (filter of filters; track filter) {
                <div
                    class="pulse-hotel-filter-group"
                    [hidden]="!isFilterVisible(filter)"
                    [ngClass]="filter.className"
                    [style.order]="filterOrder(filter)"
                    [class.pulse-filter-collapsed]="!layout.isExpanded(filter)">
                    <div class="filter-header">
                        <button
                            type="button"
                            class="pulse-filter-section-toggle"
                            (click)="toggleFilterSection(filter)"
                            [attr.aria-expanded]="layout.isExpanded(filter)"
                            [attr.aria-controls]="'pulse-filter-content-' + filter.id">
                            <i
                                class="fa"
                                [class.fa-chevron-down]="layout.isExpanded(filter)"
                                [class.fa-chevron-right]="!layout.isExpanded(filter)"
                                aria-hidden="true"></i>
                            <span [title]="filter.textHeader">{{
                                filter.id === 'cc' ? ('filters.ccOutsourcedShort' | transloco) : filter.textHeader
                            }}</span>
                        </button>
                    </div>
                    <div
                        class="filter-content"
                        [id]="'pulse-filter-content-' + filter.id"
                        [hidden]="!layout.isExpanded(filter)">
                        @if (filter.id === 'hotel' && isCompanyRHG()) {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a
                                        class="nav-link m-tabs__link pulse-hotel-row"
                                        title="{{ node.id }}-{{ node.EMMA_CODE }}-{{ node.name }} ({{ node.htl_id }}){{
                                            node.tpbacd ? ' - ' + node.tpbacd : ''
                                        }}">
                                        <span class="pulse-hotel-code">{{ node.id }}</span>
                                        <span class="pulse-hotel-reference">{{ node.EMMA_CODE }}</span>
                                        <span class="pulse-hotel-name">{{ node.name }}</span>
                                        @if (!checkAllowed(node?.htl_id)) {
                                            <span
                                                id="htl-warning"
                                                class="htl-warning"
                                                [title]="'entitySidebar.excludedFromDashboard' | transloco">
                                                <i class="la la-warning"></i>
                                            </span>
                                        }
                                    </a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.id === 'hotel' && isCompanyLHG()) {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a
                                        class="nav-link m-tabs__link pulse-hotel-row pulse-hotel-row-lhg"
                                        title="{{ node.id }}-{{ node.EMMA_CODE }}-{{ node.name }} ({{ node.htl_id }}){{
                                            node.tpbacd ? ' - TPBA: ' + node.tpbacd : ''
                                        }}">
                                        <span class="pulse-hotel-code">{{ node.id }}</span>
                                        <span class="pulse-hotel-name">{{ node.name }}</span>
                                        @if (!checkAllowed(node?.htl_id)) {
                                            <span
                                                id="htl-warning"
                                                class="htl-warning"
                                                [title]="'entitySidebar.excludedFromDashboard' | transloco">
                                                <i class="la la-warning"></i>
                                            </span>
                                        }
                                    </a>
                                </div>
                            </dx-list>
                        }
                        @if (
                            filter.type &&
                            filter.id !== 'hotel' &&
                            filter.id !== 'theatre' &&
                            filter.id !== 'rmc_flag' &&
                            filter.id !== 'cc'
                        ) {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                itemTemplate="nodes"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'theatre') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link">{{
                                        node[filter.textKey] == 1000
                                            ? 'EMEA'
                                            : node[filter.textKey] == 2000
                                              ? 'APAC'
                                              : node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'rmc_flag') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'cc') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (!filter.type) {
                            <dx-tree-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.treeSource"
                                height="var(--pulse-hotel-list-height, 220px)"
                                keyExpr="{{ filter.idKey }}"
                                parentIdExpr="parent"
                                [showRowLines]="false"
                                [showBorders]="false"
                                [columnAutoWidth]="true"
                                [showColumnHeaders]="true"
                                [(selectedRowKeys)]="filter.selectedKeys"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)"
                                [scrolling]="{ useNative: true }">
                                <dxo-selection mode="multiple" [recursive]="true" [allowSelectAll]="true">
                                </dxo-selection>
                                <dxi-column
                                    dataField="{{ filter.textKey }}"
                                    [allowSorting]="false"
                                    caption="Select All">
                                </dxi-column>
                            </dx-tree-list>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="pulse-filter-footer">
            <span>{{ 'entitySidebar.hotelsSelected' | transloco: { count: pendingHotelCount } }}</span>
            <button type="button" class="btn btn-primary" (click)="updateFilters()">
                <i class="fa fa-check" aria-hidden="true"></i>
                {{ 'entitySidebar.applyCurrent' | transloco }}
            </button>
        </div>
    </div>
</div>
<!-- end::Quick Sidebar -->
<div
    pulseTableSurface
    id="hotelList"
    class="pulse-table-tail"
    [ngClass]="showHotelList ? 'active' : 'inactive'"
    style="z-index: 999999999">
    <div class="hotel-inner">
        <div class="hotel-box">
            <div
                class="hotel-box-inner hotel-box-inner clearfix"
                [ngClass]="showHotelList ? 'hotel-box-inner_active' : 'hotel-box-inner_inactive'">
                <h2>{{ 'entitySidebar.selectedHotels' | transloco }}</h2>
                <table
                    id="hotelListDataTable"
                    class="text-align-center swiper-no-swiping table-hover"
                    style="width: 100%"></table>
                <button
                    class="btn btn-secondary float-right"
                    style="width: 100px; margin-top: 10px"
                    (click)="onHotelClose()">
                    Ok
                </button>
            </div>
        </div>
    </div>
</div>
